// Free IP geolocation service using ipapi.co
export async function detectUserCountry() {
  try {
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return data.country_code;
  } catch (error) {
    console.warn('Could not detect user country:', error);
    return null;
  }
}

// Alternative service using ip-api.com (free tier)
export async function detectUserCountryAlternative() {
  try {
    const response = await fetch('http://ip-api.com/json');
    const data = await response.json();
    return data.countryCode;
  } catch (error) {
    console.warn('Could not detect user country (alternative):', error);
    return null;
  }
}

// Main function to detect country with fallback
export async function getUserCountry() {
  try {
    const country = await detectUserCountry();
    if (country) return country;
    
    // Fallback to alternative service
    return await detectUserCountryAlternative();
  } catch (error) {
    console.warn('Failed to detect user country:', error);
    return null;
  }
}
